<template>
    <div class="shopping-wrap ptb-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-12 order-lg-1 order-1">
                    <div
                        class="shopping-img-wrap"
                        style="border-radius: 12px; overflow: hidden">
                        <img
                            v-if="this.image"
                            :src="this.image"
                            alt="Image" />
                    </div>
                </div>
                <div class="col-lg-6 col-12 order-lg-2 order-2">
                    <div class="shopping-content">
                        <img
                            src="../../assets/images/shopping/shopping-shape-1.png"
                            alt="Image"
                            class="shopping-shape-one moveHorizontal" />
                        <img
                            src="../../assets/images/shopping/shopping-shape-2.png"
                            alt="Image"
                            class="shopping-shape-two bounce" />
                        <div class="content-title style1" style="padding: 0px 25px !important;">
                            <h2 class="header-blue-tf-color text-center">{{ this.title }}</h2>
                            <p style="text-align: justify; padding: 0px !important;">
                                From <strong>June 1 to June 30, 2025,</strong> all eligible existing TOTAL clients can take 
                                advantage of our <strong>Grace Period Refinance Campaign</strong> and <strong>skip two monthly payments.</strong> 
                                To qualify, clients must be current on their existing loan, receive a <strong>minimum cash-in-hand amount of AWG 2,000,</strong> 
                                and refinance a <strong>minimum loan amount of AWG 10,000.</strong> For refinance amounts between 
                                <strong>AWG 10,000 and AWG 35,000,</strong> the applicable <strong>APR will range between 18% and 24%,</strong> with a 
                                <strong>nominal rate between 15.22% and 20.15%.</strong> No additional payments are allowed during the grace period. 
                                A <strong>prepayment penalty of 7.50% of the outstanding balance,</strong> with a <strong>minimum fee of AWG 350.00,</strong> 
                                applies in the event of early repayment. A <strong>Balance Protection Fee (BPF)</strong> may also apply. 
                                All general loan terms and conditions remain in effect. TOTAL reserves the right to extend, shorten, 
                                or withdraw this campaign at any time without prior notice.
                                <br><br>
                                <i style="font-size: 0.9rem;">* The applicable APR is determined based on the client’s risk profile and creditworthiness as assessed by TOTAL.</i>
                            </p>
                            <router-link
                                to="/terms-and-conditions"
                                class="btn style1"
                                style="float: left; margin-top: 18px;"
                                >Go to terms and conditions
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PayLater',
    props: {
        title: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            image: require("../../assets/images/campaigns/campaign-pay-later.webp"),
        };
    },
}
</script>